/* Atelier — Red Boutiques */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  /* ---------- Header ---------- */
  var header = $('[data-header]');
  function setHeaderHeight() {
    if (!header) return;
    document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', debounce(setHeaderHeight, 150));

  if (header && header.hasAttribute('data-overlay')) {
    var onScroll = function () { header.classList.toggle('is-solid', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Drawers ---------- */
  var openDrawer = null;
  var lastFocus = null;

  function open(drawer) {
    if (!drawer) return;
    if (openDrawer && openDrawer !== drawer) close(openDrawer);
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    openDrawer = drawer;
    var focusable = drawer.querySelector('input[type="search"], button, a[href]');
    if (focusable) setTimeout(function () { focusable.focus(); }, 60);
  }

  function close(drawer) {
    drawer = drawer || openDrawer;
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    openDrawer = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-menu-open]')) { e.preventDefault(); open($('[data-menu-drawer]')); return; }
    if (t.closest('[data-filter-open]')) { e.preventDefault(); open($('[data-filter-drawer]')); return; }
    if (t.closest('[data-search-open]')) { e.preventDefault(); open($('[data-search-overlay]')); return; }
    if (t.closest('[data-size-guide-open]')) { e.preventDefault(); open($('[data-size-guide]')); return; }
    if (t.closest('[data-cart-open]') && window.theme.cartType === 'drawer' && document.body.className.indexOf('template-cart') === -1) {
      e.preventDefault(); open($('[data-cart-drawer]')); return;
    }
    if (t.closest('[data-drawer-close]') || t.closest('[data-search-close]')) { e.preventDefault(); close(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if ($('[data-lightbox].is-open')) { closeLightbox(); return; }
      close();
    }
  });

  /* ---------- Announcement ---------- */
  var slides = $$('.announcement__slide');
  if (slides.length > 1) {
    var idx = 0;
    setInterval(function () {
      slides[idx].classList.remove('is-active');
      idx = (idx + 1) % slides.length;
      slides[idx].classList.add('is-active');
    }, 4500);
  }

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Animated accordions (<details>) ---------- */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function animateDetails(details) {
    var summary = details.querySelector(':scope > summary');
    if (!summary || details.hasAttribute('data-animated')) return;
    details.setAttribute('data-animated', '');
    summary.addEventListener('click', function (e) {
      if (reduceMotion || !details.animate) return;
      e.preventDefault();
      if (details._anim) details._anim.cancel();
      var cs = getComputedStyle(details);
      var borders = parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);
      var start = details.offsetHeight;
      var closing = details.open;
      details.style.overflow = 'hidden';
      var end;
      if (closing) {
        details.classList.add('is-closing');
        end = summary.offsetHeight + borders;
      } else {
        details.open = true;
        end = details.offsetHeight;
      }
      details._anim = details.animate(
        { height: [start + 'px', end + 'px'] },
        { duration: closing ? 280 : 380, easing: 'cubic-bezier(.2,.7,.2,1)' }
      );
      details._anim.onfinish = function () {
        if (closing) details.open = false;
        details.classList.remove('is-closing');
        details.style.overflow = '';
        details._anim = null;
      };
      details._anim.oncancel = function () { details.classList.remove('is-closing'); };
    });
  }
  $$('.accordion details, details.facets__group, .mobile-nav details').forEach(animateDetails);

  /* ---------- Product sliders: arrows + progress track ---------- */
  function initSlider(wrap) {
    var track = $('[data-slider]', wrap);
    if (!track || wrap.hasAttribute('data-slider-ready')) return;
    wrap.setAttribute('data-slider-ready', '');
    var prev = $('[data-slider-prev]', wrap);
    var next = $('[data-slider-next]', wrap);
    var bar = $('[data-slider-progress]', wrap);
    var thumb = $('[data-slider-thumb]', wrap);

    function step() {
      var item = track.firstElementChild;
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var perView = Math.max(1, Math.floor((track.clientWidth + gap) / (item.offsetWidth + gap)));
      return (item.offsetWidth + gap) * perView;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      wrap.classList.toggle('is-static', max <= 2);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (bar && thumb) {
        var ratio = track.clientWidth / track.scrollWidth;
        var barW = bar.clientWidth;
        var thumbW = Math.max(40, barW * ratio);
        thumb.style.width = thumbW + 'px';
        var progress = max > 0 ? track.scrollLeft / max : 0;
        thumb.style.transform = 'translateX(' + (barW - thumbW) * progress + 'px)';
      }
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', debounce(update, 100));

    // Click or drag the progress track to scrub through products.
    if (bar && thumb) {
      var dragging = false;
      function scrubTo(clientX) {
        var rect = bar.getBoundingClientRect();
        var thumbW = thumb.offsetWidth;
        var p = (clientX - rect.left - thumbW / 2) / (rect.width - thumbW);
        p = Math.min(1, Math.max(0, p));
        track.scrollLeft = p * (track.scrollWidth - track.clientWidth);
      }
      bar.addEventListener('pointerdown', function (e) {
        dragging = true;
        bar.classList.add('is-dragging');
        track.style.scrollSnapType = 'none';
        bar.setPointerCapture(e.pointerId);
        scrubTo(e.clientX);
      });
      bar.addEventListener('pointermove', function (e) { if (dragging) scrubTo(e.clientX); });
      function endDrag() {
        if (!dragging) return;
        dragging = false;
        bar.classList.remove('is-dragging');
        track.style.scrollSnapType = '';
      }
      bar.addEventListener('pointerup', endDrag);
      bar.addEventListener('pointercancel', endDrag);
    }

    update();
  }
  $$('[data-slider-wrap]').forEach(initSlider);
  window.theme.initSlider = initSlider;

  /* ---------- Cart ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.setAttribute('data-count', count);
    });
  }

  function renderDrawer(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = doc.querySelector('[data-cart-contents]');
    var current = $('[data-cart-contents]');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  function refreshCart() {
    return fetch(routes.root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(renderDrawer)
      .then(function () { return fetch(routes.cart + '.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); return cart; });
  }

  function addToCart(formData, button) {
    if (button) button.classList.add('is-loading');
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);
    return fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'Could not add to bag');
        if (window.theme.cartType !== 'drawer') { window.location.href = routes.cart; return; }
        renderDrawer(res.sections);
        return fetch(routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
          updateCount(cart.item_count);
          open($('[data-cart-drawer]'));
        });
      })
      .finally(function () { if (button) button.classList.remove('is-loading'); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('[data-product-form]') || form.matches('[data-quick-add]')) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var err = form.querySelector('[data-form-error]');
      if (err) err.hidden = true;
      addToCart(new FormData(form), btn).catch(function (error) {
        if (err) { err.textContent = error.message; err.hidden = false; }
      });
    }
  });

  function changeLine(line, quantity) {
    var drawer = $('[data-cart-contents]');
    if (drawer) drawer.style.opacity = '.5';
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: ['cart-drawer'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if ($('[data-cart-page]')) { window.location.reload(); return; }
        renderDrawer(cart.sections);
        updateCount(cart.item_count);
      })
      .finally(function () { var d = $('[data-cart-contents]'); if (d) d.style.opacity = ''; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    e.preventDefault();
    var item = btn.closest('[data-line]');
    changeLine(parseInt(item.getAttribute('data-line'), 10), parseInt(btn.getAttribute('data-qty-change'), 10));
  });

  document.addEventListener('input', debounce(function (e) {
    if (!e.target.matches('[data-cart-note]')) return;
    fetch(routes.cart + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: e.target.value })
    });
  }, 400));

  /* ---------- Predictive search ---------- */
  var searchInput = $('[data-search-input]');
  var searchResults = $('[data-search-results]');
  var defaultResults = searchResults ? searchResults.innerHTML : '';
  var searchController;
  if (searchInput && searchResults) {
    searchInput.addEventListener('input', debounce(function () {
      var q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = defaultResults; return; }
      if (searchController) searchController.abort();
      searchController = 'AbortController' in window ? new AbortController() : null;
      var url = routes.predictiveSearch + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=10&resources[options][unavailable_products]=last&section_id=predictive-search';
      fetch(url, searchController ? { signal: searchController.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var res = doc.querySelector('[data-predictive-results]');
          searchResults.innerHTML = res ? res.innerHTML : '';
        })
        .catch(function () {});
    }, 220));
  }

  /* ---------- Collection: sort, filters, density ---------- */
  var sort = $('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // Filter groups: "Show all" toggle and in-group search for long lists.
  $$('[data-facet]').forEach(function (group) {
    var list = $('[data-facet-list]', group);
    var more = $('[data-facet-more]', group);
    var search = $('[data-facet-search]', group);
    if (more) {
      more.addEventListener('click', function () {
        var collapsed = list.classList.toggle('is-collapsed');
        more.textContent = collapsed ? more.getAttribute('data-label-more') : more.getAttribute('data-label-less');
      });
    }
    if (search) {
      search.addEventListener('input', function () {
        var q = search.value.trim().toLowerCase();
        list.classList.toggle('is-searching', q.length > 0);
        if (more) more.hidden = q.length > 0;
        $$('[data-facet-value]', list).forEach(function (el) {
          el.classList.toggle('is-match', q.length > 0 && el.getAttribute('data-facet-value').indexOf(q) !== -1);
        });
      });
      search.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
    }
  });

  var applyBtn = $('[data-filter-apply]');
  if (applyBtn) {
    applyBtn.addEventListener('click', function () {
      var form = $('[data-filter-form]');
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) { if (value !== '') params.append(key, value); });
      window.location.href = window.location.pathname + '?' + params.toString();
    });
  }

  var grid = $('[data-product-grid]');
  var colButtons = $$('[data-cols]');
  function setCols(n) {
    if (!grid) return;
    grid.style.setProperty('--cols', n);
    colButtons.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-cols') === String(n)); });
    try { localStorage.setItem('atelier-cols', n); } catch (err) {}
  }
  if (grid && colButtons.length) {
    var saved = null;
    try { saved = localStorage.getItem('atelier-cols'); } catch (err) {}
    if (saved) setCols(saved);
    colButtons.forEach(function (b) { b.addEventListener('click', function () { setCols(b.getAttribute('data-cols')); }); });
  }

  /* ---------- Product ---------- */
  var productEl = $('[data-product]');
  if (productEl) {
    var jsonEl = $('[data-product-json]', productEl);
    var data = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var form = $('[data-product-form]', productEl);
    var fieldsets = $$('fieldset[data-option-index]', productEl);
    var gallery = $('[data-gallery]', productEl);

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function updateAvailability(opts) {
      fieldsets.forEach(function (fs, i) {
        $$('input', fs).forEach(function (input) {
          var test = opts.slice(); test[i] = input.value;
          var match = data.variants.find(function (v) {
            return v.available && v.options.every(function (o, j) { return o === test[j]; });
          });
          input.classList.toggle('is-unavailable', !match);
        });
        var label = fs.querySelector('[data-option-selected]');
        if (label) label.textContent = opts[i] || '';
      });
    }

    function priceHtml(v) {
      return '<span class="price' + (v.compare ? ' price--sale' : '') + '"><span class="price__current">' + v.price + '</span>' +
        (v.compare ? '<s class="price__compare">' + v.compare + '</s>' : '') + '</span>';
    }

    function onVariantChange() {
      var opts = selectedOptions();
      var v = findVariant(opts);
      updateAvailability(opts);
      var addBtn = $('[data-add-button]', productEl);
      var addLabel = $('[data-add-label]', productEl);
      var stickyBtn = $('[data-sticky-add]', productEl);
      var stock = $('[data-stock]', productEl);

      if (!v) {
        addBtn.disabled = true; addLabel.textContent = 'Unavailable';
        if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = 'Unavailable'; }
        if (stock) { stock.className = 'product__stock product__stock--out'; stock.textContent = 'Unavailable'; }
        return;
      }

      $('[data-variant-id]', productEl).value = v.id;
      $$('[data-product-price]', productEl).forEach(function (el) {
        var large = el.closest('.product__price');
        el.innerHTML = priceHtml(v);
        if (large) el.firstChild.classList.add('price--large');
      });
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Add to bag' : 'Sold out';
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? 'Add to bag' : 'Sold out'; }
      if (stock) {
        if (!v.available) { stock.className = 'product__stock product__stock--out'; stock.textContent = 'Sold out'; }
        else if (v.qty !== null && v.qty > 0 && v.qty <= 2) { stock.className = 'product__stock product__stock--low'; stock.textContent = 'Only ' + v.qty + ' left'; }
        else { stock.className = 'product__stock'; stock.textContent = 'In stock'; }
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());

      if (v.media_id && gallery) {
        var target = gallery.querySelector('[data-media-id="' + v.media_id + '"]');
        if (target) {
          if (window.matchMedia('(min-width: 990px)').matches) {
            if (target !== gallery.firstElementChild) gallery.insertBefore(target, gallery.firstElementChild);
          } else {
            gallery.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
          }
        }
      }
    }

    if (data && fieldsets.length) {
      fieldsets.forEach(function (fs) { fs.addEventListener('change', onVariantChange); });
      updateAvailability(selectedOptions());
    }

    // Swatch hover: preview the color name in the legend, restore on leave.
    $$('.option--swatch', productEl).forEach(function (fs) {
      var label = fs.querySelector('[data-option-selected]');
      if (!label) return;
      $$('[data-swatch-label]', fs).forEach(function (sw) {
        sw.addEventListener('mouseenter', function () { label.textContent = sw.getAttribute('data-swatch-label'); });
        sw.addEventListener('mouseleave', function () {
          var checked = fs.querySelector('input:checked');
          label.textContent = checked ? checked.value : '';
        });
      });
    });

    // Gallery dots (mobile)
    var dots = $$('[data-gallery-dots] span', productEl);
    if (gallery && dots.length) {
      gallery.addEventListener('scroll', debounce(function () {
        var i = Math.round(gallery.scrollLeft / gallery.clientWidth);
        dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
      }, 60), { passive: true });
    }

    // Sticky add to bag (mobile)
    var sticky = $('[data-sticky-atc]', productEl);
    var buy = $('[data-add-button]', productEl);
    if (sticky && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var visible = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }).observe(buy);
      var stickyAdd = $('[data-sticky-add]', productEl);
      if (stickyAdd) stickyAdd.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else buy.click();
      });
    }

    // Lightbox (desktop)
    var lightbox = $('[data-lightbox]');
    $$('[data-zoom]', productEl).forEach(function (m) {
      m.addEventListener('click', function () {
        if (!window.matchMedia('(min-width: 990px)').matches || !lightbox) return;
        var content = $('[data-lightbox-content]', lightbox);
        content.innerHTML = '';
        $$('[data-zoom] img', productEl).forEach(function (img) {
          var big = new Image();
          big.src = img.currentSrc || img.src;
          big.srcset = img.srcset; big.sizes = '100vw'; big.alt = img.alt;
          content.appendChild(big);
        });
        lightbox.classList.add('is-open');
        document.body.classList.add('is-locked');
        var clicked = $$('[data-zoom] img', productEl).indexOf(m.querySelector('img'));
        var targetImg = content.children[clicked];
        if (targetImg) setTimeout(function () { targetImg.scrollIntoView(); }, 30);
      });
    });
    if (lightbox) lightbox.addEventListener('click', closeLightbox);
  }

  function closeLightbox() {
    var lb = $('[data-lightbox]');
    if (!lb) return;
    lb.classList.remove('is-open');
    document.body.classList.remove('is-locked');
  }

  /* ---------- Recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    fetch(el.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          $$('[data-slider-wrap]', el).forEach(initSlider);
        }
      })
      .catch(function () {});
  });

  /* ---------- Signup popup ---------- */
  (function () {
    var popup = $('[data-signup-popup]');
    if (!popup) return;
    var teaser = $('[data-popup-teaser]');
    var sectionId = popup.getAttribute('data-section-id');
    var designMode = popup.getAttribute('data-design-mode') === 'true';
    var code = popup.getAttribute('data-code');
    var days = parseInt(popup.getAttribute('data-days'), 10) || 14;
    var KEY_SUB = 'rb-popup-subscribed', KEY_UNTIL = 'rb-popup-hidden-until', KEY_TEASER = 'rb-teaser-hidden-until';
    var store = {
      get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
      set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
    };
    var opened = false;

    function showTeaser() {
      if (!teaser || designMode) return;
      var until = parseInt(store.get(KEY_TEASER), 10) || 0;
      teaser.hidden = Date.now() < until;
    }
    function openPopup() {
      if (popup.classList.contains('is-open')) return;
      opened = true;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-locked');
      if (teaser) teaser.hidden = true;
      var input = popup.querySelector('input[type="email"]');
      if (input && window.matchMedia('(min-width: 750px)').matches) setTimeout(function () { input.focus(); }, 400);
    }
    function closePopup(remember) {
      if (!popup.classList.contains('is-open')) return;
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-locked');
      if (designMode) return;
      if (remember !== false && !store.get(KEY_SUB)) {
        store.set(KEY_UNTIL, String(Date.now() + days * 864e5));
        showTeaser();
      }
    }

    $$('[data-popup-close]', popup).forEach(function (el) { el.addEventListener('click', function () { closePopup(); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePopup(); });

    if (teaser) {
      teaser.addEventListener('click', function (e) {
        if (e.target.closest('[data-teaser-dismiss]')) {
          e.stopPropagation();
          teaser.hidden = true;
          store.set(KEY_TEASER, String(Date.now() + days * 864e5));
          return;
        }
        openPopup();
      });
    }

    var copyBtn = $('[data-popup-copy]', popup);
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var text = $('[data-popup-code]', popup).textContent.trim();
        (navigator.clipboard ? navigator.clipboard.writeText(text) : Promise.reject()).then(function () {
          copyBtn.textContent = 'Copied';
          copyBtn.classList.add('is-copied');
        }).catch(function () {});
      });
    }

    // Theme editor: open immediately when "Preview in theme editor" is on; never auto-trigger otherwise.
    if (designMode) {
      if (popup.getAttribute('data-preview') === 'true') openPopup();
      return;
    }

    // Respect the "Show on mobile" setting.
    if (popup.getAttribute('data-mobile') === 'false' && window.matchMedia('(max-width: 749px)').matches) return;

    // Returning from a signup (Shopify redirects back with ?customer_posted=true#FormId).
    var posted = /customer_posted=true/.test(window.location.search);
    var hash = window.location.hash || '';
    if (posted && /Newsletter|PopupSignup/.test(hash)) store.set(KEY_SUB, '1');
    if (hash === '#PopupSignup-' + sectionId) {
      if (posted && code && $('[data-popup-success]', popup)) {
        fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
      }
      openPopup();
      history.replaceState(null, '', window.location.pathname + window.location.search.replace(/[?&]customer_posted=true/, ''));
      return;
    }

    if (store.get(KEY_SUB)) return;
    var until = parseInt(store.get(KEY_UNTIL), 10) || 0;
    if (Date.now() < until) { showTeaser(); return; }

    var delay = parseInt(popup.getAttribute('data-delay'), 10);
    if (!isNaN(delay)) setTimeout(function () { if (!opened) openPopup(); }, delay * 1000);

    var scrollPct = parseInt(popup.getAttribute('data-scroll'), 10) || 0;
    if (scrollPct > 0) {
      var onScroll = function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h > 0 && window.scrollY / h * 100 >= scrollPct) {
          window.removeEventListener('scroll', onScroll);
          if (!opened) openPopup();
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    if (popup.getAttribute('data-exit-intent') === 'true' && window.matchMedia('(hover: hover)').matches) {
      document.addEventListener('mouseout', function onOut(e) {
        if (!e.relatedTarget && e.clientY <= 0) {
          document.removeEventListener('mouseout', onOut);
          if (!opened) openPopup();
        }
      });
    }
  })();

  /* ---------- Address forms: preselect country ---------- */
  $$('select[data-default]').forEach(function (sel) {
    var val = sel.getAttribute('data-default');
    if (val) sel.value = val;
  });

  window.theme.refreshCart = refreshCart;
})();
